import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { Manufacturer } from '../../types';

interface ManufacturerState {
  selectedManufacturer: Manufacturer | null;
}

const initialState: ManufacturerState = {
  selectedManufacturer: null,
};

export const manufacturerSlice = createSlice({
  name: 'manufacturer',
  initialState,
  reducers: {
    setSelectedManufacturer: (
      state: ManufacturerState,
      action: PayloadAction<Manufacturer | null>
    ) => {
      state.selectedManufacturer = action.payload;
    },
    clearSelectedManufacturer: state => {
      state.selectedManufacturer = null;
    },
  },
});

export const { setSelectedManufacturer, clearSelectedManufacturer } = manufacturerSlice.actions;

// Selectors
export const selectSelectedManufacturer = (state: RootState) =>
  state.manufacturer.selectedManufacturer;

export default manufacturerSlice.reducer;
